import { Component, Input } from '@angular/core';
import { GlobalConstants } from '../../global-constants';
import { PaseosComponent } from '../paseos.component';
import { LoaderService } from '../../comun/services/loader.service';

@Component({
  selector: 'app-paseo',
  templateUrl: './paseo.component.html',
  styleUrls: ['./paseo.component.css']
})
export class PaseoComponent {
  @Input() paseo: any;

  constructor(public paseos: PaseosComponent, public loader: LoaderService) {}

  masInformacion() {
    this.loader.show();
    window.location.href = GlobalConstants.urlServer + 'paseo/' + this.paseo.pa_id;
  }

  editarPaseo(paseo: any) {
    this.paseos.paseo = paseo;
    this.paseos.publicar = true;    
  }

}
